module.exports = __webpack_public_path__ + "img/32.9dee9811.png";